import Vue from 'vue'

import { BootstrapVue, BBreadcrumb } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.component('b-breadcrumb', BBreadcrumb)

Vue.use(BootstrapVue)
